'use client';
import { useEffect, useState } from 'react';

/**
 * Get the current url from the browser
 * Only works client side
 * @param withFragment - if true, the url will include the fragment
 * @returns the current url
 */
export const useUrl = (
  { withFragment }: { withFragment: boolean } = { withFragment: false }
) => {
  const [url, setUrl] = useState<string>();

  useEffect(() => {
    setUrl(
      withFragment ? window.location.href : window.location.href.split('#')[0]
    );
  }, []);

  return url;
};
